module.exports = __webpack_public_path__ + "static/media/trainingSocializationIcon.614fbde5.png";